export default __webpack_public_path__ + "static/media/dual-token-mobile.fa24d615.png";